<!--
アンケート結果
URL：question/result
-->

<template>
  <div>
    <v-container style="max-width: 800px">
      <p class="text-center text-h3">アンケート結果</p>
      <v-row justify="center" style="text-align: center">
        <v-col cols="3" class="d-flex align-center justify-end">
          グループ選択
        </v-col>
        <v-col cols="6" class="d-flex align-center">
          <v-select
              :items="[
                  { text: '全てのグループ', value: 'allGroup' },
                  ...groupList.map(group => ({
                    text: group.display_name,
                    value: group.group_id
                  }))
              ]"
              v-model="selectedGroup"
              class="fixed-width-600"
              dense
              hide-details
              return-object
              outlined
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-btn color="primary" class="ma-2" width="150" @click="downloadCSV"
            >ダウンロード</v-btn
          >
        </v-col>
      </v-row>
      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">
          タイトル
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              {{ questionData.title }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="custom-card-title">説明</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              {{ questionData.description }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="custom-card-title">開始日</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              {{ questionData.started_at }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="custom-card-title">終了日</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              {{ questionData.ended_at }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
          v-for="(item, index) in questionData.items"
          :key="index"
          elevation="5"
          class="ma-4"
      >
        <v-card-title class="custom-card-title jutsity-between">
          設問{{ index + 1 }}
        </v-card-title>
        <v-card-subtitle class="custom-card-subtitle mt-0">説明</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              {{ item.description }}
            </v-col>
          </v-row>
        </v-card-text>
        <template v-if="typeHasOption(item.type)">
          <v-card-subtitle class="custom-card-subtitle">選択肢</v-card-subtitle>
          <v-card-text>
            <v-row v-for="(option, index) in item.options" :key="index">
              <v-col cols="3">
                {{ option.value }}
              </v-col>
              <v-col cols="3">
                {{ "回答数：" + questionOptionCount(option) }}
              </v-col>
            </v-row>
            <GChart
              :type="getChartType(item)"
              :data="getChartData(item)"
              :options="getChartOptions(item)"
            />
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text>
            <v-row v-for="(text, index) in getAnswerTextList()" :key="index">
              <v-col cols="12">
                {{ text }}
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </v-card>

    </v-container>
  </div>
</template>

<script>
import Api from "@/logic/api/api.js";
import { GChart } from "vue-google-charts/legacy";

export default {
  components: {
    GChart,
  },
  data() {
    return {
      id: '',
      questionData: {
        title: null,
        description: null,
        started_at: null,
        ended_at: null,
        items: [],
      },
      answerData: {
        answers: [],
      },
      userList: [],
      groupList: [],
      selectedGroup: {
        text: '全てのグループ',
        value: 'allGroup',
      },
    };
  },
  watch: {
    selectedGroup() {
      console.log('watch selectedGroup');
    }
  },
  mounted() {
    this.id = Number(this.$route.params.uid);
    this.$store.commit("setWaiting", true);
    // アンケートを取得する
    Api.call("/question", {"id": this.id})
      .then((result) => {
        this.$store.commit("setWaiting", false);
        this.questionData.title = result.title;
        this.questionData.description = result.description;
        this.questionData.started_at = result.started_at;
        this.questionData.ended_at = result.ended_at;
        this.questionData.items = result.items
          .map(el => ({...el, 
            options: this.typeHasOption(el.type) ? el.options : null
          }))
      })
      .catch((result) => {
        this.$store.commit("setWaiting", false);
        Api.resolve(result);
      });

    // アンケート結果を取得する
    this.$store.commit("setWaiting", true);
    Api.call("/answer/get", {"id": this.id})
        .then((result) => {
          this.$store.commit("setWaiting", false);
          this.answerData.answers = result.answers;
        })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        });

    // ユーザ一覧を取得する
    this.$store.commit("setWaiting", true);
    Api.call("/admin/user", {
          purpose: "USER_MANAGEMENT",
        })
      .then((result) => {
        this.$store.commit("setWaiting", false);
        this.userList = result.users;
      })
      .catch((result) => {
        this.$store.commit("setWaiting", false);
        Api.resolve(result);
      });
    
    // グループ一覧を取得する
    this.$store.commit("setWaiting", true);
    Api.call("/admin/group", {
        purpose: "GROUP_MANAGEMENT",
        no_detail: true,
      })
      .then((result) => {
        this.$store.commit("setWaiting", false);
        this.groupList = result.group_list;
      })
      .catch((result) => {
        this.$store.commit("setWaiting", false);
        Api.resolve(result);
      });
  },
  methods: {
    typeHasOption(type) {
      return type === 'radio' || type === 'checkbox';
    },
    getChartType(item) {
      if (item.type === 'radio') {
        return "PieChart";
      } else if (item.type === 'checkbox') {
        return "BarChart";
      }
    },
    getChartData(item) {
      let chartData = [];
      // ヘッダ情報をセット
      chartData.push(["選択肢", "回答数"]);
      item.options.forEach(option => {
        chartData.push([option.value, this.questionOptionCount(option)]);
      });
      return chartData;
    },
    getChartOptions(item) {
      // グラフ表示オプション設定
      if (item.type === 'radio') {
        return null;
      } else if (item.type === 'checkbox') {
        return {
          hAxis: {
            gridlines: { count: 0 }, // X軸の罫線を非表示
            format: 'decimal', // 整数表示
          },
          legend: {
            position: 'none',
          },
        };
      }
    },
    questionOptionCount(questionOption) {
      let count = 0;
      this.answerData.answers.forEach(answer => {
        if (this.selectedGroup.value == "allGroup" || answer.group_list.includes(this.selectedGroup.value)) {
          answer.items.forEach(item => {
            item.options.forEach(option => {
              if (option.question_option_id === questionOption.id) {
                  count++;
              }
            });
          });
        }
      });
      return count;
    },
    downloadCSV() {
      // CSVデータの生成
      const csvRows = [];
      // ヘッダーの作成
      const headers = [];
      headers.push(`"${"回答日時"}"`);
      headers.push(`"${"ユーザー名"}"`);
      headers.push(`"${"所属グループ名"}"`);
      for (const item of this.questionData.items) {
        headers.push(`"${item.description}"`);
      }
      csvRows.push(headers.join(','));
      for (const answer of this.answerData.answers) {
        if (this.selectedGroup.value == "allGroup" || answer.group_list.includes(this.selectedGroup.value)) {
          const answerRow = [];
          answerRow.push(`"${this.toJapanDate(answer.created_at)}"`);
          answerRow.push(`"${this.getUserName(answer.user_id)}"`);
          answerRow.push(`"${this.getGroupName(answer.group_list)}"`);
          for (const item of answer.items) {
            const questionItem = this.questionData.items.find(e => e.id === item.question_item_id);
            if (questionItem.type == "radio" || questionItem.type == "checkbox") {
              var answerAll = null;
              for (const option of item.options) {
                const questionOption = questionItem.options.find(e => e.id === option.question_option_id);
                if (item.options.indexOf(option) == 0) {
                  answerAll = questionOption.value;
                } else {
                  answerAll += ";" + questionOption.value;
                }
              }
              answerRow.push(`"${answerAll}"`);
            }
            if (questionItem.type == "text") {
              answerRow.push(`"${item.value}"`);
            }
          }
          csvRows.push(answerRow.join(','));
        }
      }

      // CSVデータを文字列に
      const csvData = "\uFEFF" + csvRows.join('\r\n');

      // データをBlobオブジェクトに変換
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });

      // ダウンロード用のURLを作成
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "answers.csv");
      document.body.appendChild(link);
      link.click(); // リンクをクリックしてダウンロード
      document.body.removeChild(link); // リンクを削除
      URL.revokeObjectURL(url); // メモリを解放
    },
    toJapanDate(utcDateString){
      // Dateオブジェクトを作成
      const date = new Date(utcDateString);
      // 日本時間 (JST) に変換
      const options = {
          timeZone: 'Asia/Tokyo',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
      };
      const jstDateString = date.toLocaleString('ja-JP', options);
      console.log(jstDateString); // "2024/10/22 15:59:34" のような出力
      return jstDateString;
    },
    getAnswerTextList(){
      const answerTextList = [];
      this.answerData.answers.forEach(answer => {
        if (this.selectedGroup.value == "allGroup" || answer.group_list.includes(this.selectedGroup.value)) {
          answer.items.forEach(item => {
              if (item.value !== null && item.value !== "") { // valueがnull/空文字でない場合
                answerTextList.push(item.value); // valueをリストに追加
              }
          });
        }
      });
      return answerTextList;
    },
    getUserName(uid) {
      const user = this.userList.find(user => user.uid === uid); // uidでユーザーを検索
      return user ? user.display_name : null; // 見つかった場合はdisplay_nameを返し、見つからなければnullを返す
    },
    getGroupName(group_list) {
      return this.groupList
        .filter(group => group_list.includes(group.group_id)) // group_idがgroup_listに含まれるものをフィルタリング
        .map(group => group.display_name) // display_nameを取得
        .join(';'); // セミコロンで繋げる
    },
  },
};
</script>

<style scoped>
.card-warning {
  background-color: #fff8dc;
}

.card-error {
  background-color: #ffdbe2;
}

.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}

.custom-card-subtitle {
  font-size: 24px;
  line-height: 1.5;
}

.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
}

.big-checkbox {
  transform: scale(1.4);
  transform-origin: 0% 50%;
  font-size: 24px;
  /* margin-left: 24px; */
  margin-right: 24px;
}

.v-text-field >>> input {
  font-size: 24px;
  padding: 0 !important;
}

.big-radio-group {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 32px;
  margin-right: 32px;
}
</style>
